import React, { useState, useRef, useEffect } from 'react';

import UpdateDateTime from 'components/features/UpdateDateTime';
import OrderList from 'components/features/trade-history/OrderList';
import NothingMessageView from 'components/features/NothingMessageView';

import * as api from 'config/api';
import { useLoading } from 'hooks/useLoadign';

const TradeHistory: React.FC = () => {
  const [asset, setAsset] = useState<api.GetAssetResult | undefined>(undefined);
  const [brokers, setBrokers] = useState<
    api.GetUserBrokerResultItem[] | undefined
  >(undefined);
  const [showOrderList, setShowOrderList] = useState<boolean>(false);
  const unmounted = useRef<boolean>(false);

  // ローディング対応
  const [, { disableLoading }] = useLoading(true);
  const [orderAPILoaded, setOrderAPILoaded] = useState(false);
  useEffect(() => {
    if (asset && brokers && (!showOrderList || orderAPILoaded)) {
      disableLoading();
    }
  }, [asset, brokers, disableLoading, showOrderList, orderAPILoaded]);

  useEffect(() => {
    setShowOrderList(
      brokers !== undefined &&
        brokers.length > 0 &&
        asset !== undefined &&
        asset.Items.length > 0
    );
  }, [asset, brokers]);

  useEffect(() => {
    api.getAsset().then(ret => {
      !unmounted.current && ret && setAsset(ret);
    });
    api.getUserBroker().then(ret => {
      !unmounted.current && ret && setBrokers(ret.Items);
    });

    return (): void => {
      // unmount
      unmounted.current = true;
    };
  }, []);

  const updateBrokers = (brokers: api.GetUserBrokerResultItem[]) => {
    setBrokers(brokers);
  };

  return (
    <div className="ui-gradient-mt">
      <div className="flex">
        <UpdateDateTime brokers={brokers} updateBrokers={updateBrokers} />
      </div>

      <NothingMessageView brokers={brokers} asset={asset} />

      {showOrderList && (
        <OrderList
          setAPILoaded={(): void => setOrderAPILoaded(true)}
          brokers={brokers}
        />
      )}
    </div>
  );
};

export default TradeHistory;
